import React, { useEffect,useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./AppHome.css";
import "../Admin/Admin.css";
import Header from "../Home/Header";

export default function MemberActivitySelection() {
  const [memberId, setMemberId] = useState("");
  const [memberInfo, setMemberInfo] = useState(null);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [categories, setCategories] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [selectedCategories, setSelectedCategories] = useState({});
  const [selectedActivities, setSelectedActivities] = useState({});

  const navigate = useNavigate();

      useEffect(() => {
        const role = sessionStorage.getItem("userRole");
        if (!role) navigate("/");
      }, [navigate]);

  // ------------------------------
  // FETCH ALL CATEGORIES
  // ------------------------------
  const fetchCategories = async () => {
    try {
      const res = await axios.get(
        "https://gym-invoice-back.onrender.com/api/categories"
      );
      setCategories(res.data);

      let expandObj = {};
      res.data.forEach((cat) => (expandObj[cat.id] = false));
      setExpanded(expandObj);
    } catch (err) {
      alert("Failed to load categories");
    }
  };

  // ------------------------------
  // SEARCH MEMBER
  // ------------------------------
  const searchMember = async () => {
    try {
      const res = await axios.get(
        `https://gym-invoice-back.onrender.com/api/members/by-member-id/${memberId}`
      );
      setMemberInfo(res.data);
      fetchCategories();
    } catch (err) {
      alert("Member not found");
      setMemberInfo(null);
    }
  };

  // ------------------------------
  // TOGGLE CATEGORY
  // ------------------------------
  const toggleCategory = (catId, activities) => {
    const isChecked = !selectedCategories[catId];

    setSelectedCategories({
      ...selectedCategories,
      [catId]: isChecked,
    });

    let updatedActivities = { ...selectedActivities };
    activities.forEach((act) => {
      updatedActivities[act.id] = isChecked;
    });

    setSelectedActivities(updatedActivities);
  };

  // ------------------------------
  // TOGGLE ACTIVITY
  // ------------------------------
const toggleActivity = (catId, actId, activities) => {
  setSelectedActivities((prev) => {
    const newValue = !prev[actId];

    const updated = {
      ...prev,
      [actId]: newValue,
    };

    const anySelected = activities.some((a) => updated[a.id]);
    const allSelected = activities.every((a) => updated[a.id]);

    // ✅ If at least one activity is selected → Category should remain checked
    // ❌ Do NOT uncheck category when unchecking activity
    // ❌ Uncheck category only when zero activities are selected
    setSelectedCategories((prevCat) => ({
      ...prevCat,
      [catId]: anySelected, // true if ANY activity selected, false if NONE selected
    }));

    return updated;
  });
};


  // ------------------------------
  // SUBMIT
  // ------------------------------
  const handleSubmitSelection = () => {
    const selectedList = [];

    categories.forEach((cat) => {
      cat.activities.forEach((act) => {
        if (selectedActivities[act.id]) {
          selectedList.push({
            category: cat.name,
            activityId: act.id,
            name: act.name,
            count: act.count,
          });
        }
      });
    });

    navigate("/summary", {
      state: {
        memberId,
        memberName: memberInfo.name,
        selectedActivities: selectedList,
        fromDate,
        toDate,
      },
    });
  };

  return (
    <div className="dashboard">
      <Header />

      <div className="payment-wrapper">
        <div className="payment-container">
          <h2>Select Activities for Member</h2>

          {/* SEARCH MEMBER */}
          <div className="search-box">
            <input
              type="text"
              placeholder="Enter Member ID"
              value={memberId}
              onChange={(e) => setMemberId(e.target.value)}
            />
            <button onClick={searchMember}>Search</button>
          </div>

          {/* MEMBER INFO */}
          {memberInfo && (
            <div>
              <h3>Member: {memberInfo.name}</h3>

              {/* DATE RANGE */}
              <div className="payment-card">
                <label>From: </label>
                <input
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />

                <label style={{ marginLeft: 10 }}>To: </label>
                <input
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>

              <hr />

              <h3>Select Categories & Activities</h3>

              {/* CATEGORY + ACTIVITIES LIST */}
              {categories.map((cat) => (
                <div key={cat.id} className="category-box">
                  {/* CATEGORY HEADER */}
                  <div className="category-row">
                    <div className="category-left">
                      <input
                        type="checkbox"
                        checked={selectedCategories[cat.id] || false}
                        onChange={() =>
                          toggleCategory(cat.id, cat.activities)
                        }
                      />
                      <span className="category-name">{cat.name}</span>
                    </div>

                   <button
                     className="toggle-btn"
                     onClick={() =>
                       setExpanded({ ...expanded, [cat.id]: !expanded[cat.id] })
                     }
                   >
                     {expanded[cat.id] ? "▲ Hide" : "▼ Show"}
                   </button>

                  </div>

                  {/* ACTIVITIES */}
                  {expanded[cat.id] && (
                    <div className="activity-list">
                      {cat.activities.map((act) => (
                        <div key={act.id} className="activity-item">
                          <div className="activity-info">
                            <span className="activity-name">
                              {act.name}
                            </span>
                            <span className="activity-count">
                              {act.count}
                            </span>
                          </div>

                          <input
                            type="checkbox"
                            className="activity-checkbox"
                            checked={selectedActivities[act.id] || false}
                            onChange={() =>
                              toggleActivity(cat.id, act.id, cat.activities)
                            }
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}

              {/* ONE FINAL SUBMIT BUTTON */}
              <button
                className="pay-button"
                style={{ marginTop: "20px" }}
                onClick={handleSubmitSelection}
              >
                Submit
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
